import React from 'react'
import { useHistory } from 'react-router-dom'
import { useUsers } from '@state/uses/users'
import { getAllUsers } from '@state/actions/users'
import ExpandButton from '@components/Buttons/ExpandButton'
import PaginatedTable from '@components/Table/PaginatedTable'
import UserExpandedRow from '@components/Users/UserExpandedRow'
import { EditBtn, ListBtn } from '@components/Table/TableButtons'
import i18n from '@localization/i18n'

const filters = [
    {
        property: 'choreographer_type',
        label: i18n.t('users_table_filters.choreographer_type'),
        placeholder: i18n.t('users_table_filters.choreographer_type'),
    },
    {
        property: 'status',
        label: i18n.t('users_table_filters.status'),
        placeholder: i18n.t('users_table_filters.status'),
    },
    {
        property: 'dance_registered_limit',
        label: i18n.t('users_table_filters.max_parallel_orders'),
        placeholder: i18n.t('users_table_filters.max_parallel_orders'),
        type: 'int',
    },
]

export default ({}) => {
    const history = useHistory()
    const columns = [
        {
            property: 'first_name',
            label: i18n.t('users_table.first_name'),
            dataScope: 'col',
            align: 'start',
            minWidth: '60px',
            sortable: true,
            isMobileTileHeader: true,
        },
        {
            property: 'last_name',
            label: i18n.t('users_table.last_name'),
            dataScope: 'col',
            align: 'start',
            minWidth: '72px',
            sortable: true,
            isMobileTileHeader: true,
        },
        {
            property: 'status',
            label: i18n.t('users_table.status'),
            align: 'start',
            minWidth: 'none',
            sortable: true,
        },
        {
            property: 'ordered_dances_counter',
            label: i18n.t('users_table.ordered'),
            align: 'start',
            minWidth: 'none',
            sortable: true,
        },
        {
            property: 'approved_dances_counter',
            label: i18n.t('users_table.confirmed'),
            align: 'start',
            minWidth: 'none',
            sortable: true,
        },
        {
            property: 'existing_dances_counter',
            label: i18n.t('users_table.exists'),
            align: 'start',
            minWidth: 'none',
            sortable: true,
        },
        {
            property: 'dance_registered_limit',
            label: i18n.t('users_table.max_parallel_orders'),
            sortable: true,
            export: true,
            type: 'int',
        },

        {
            property: 'is_admin',
            label: i18n.t('users_table.admin'),
            align: 'center',
            sortable: true,
            minWidth: 'none',
            cell: (r) => (r.is_admin ? i18n.t('users_table.admin') : ''),
        },
        {
            property: 'goToSongdList',
            label: i18n.t('users_table.dances'),
            align: 'center',
            minWidth: 'none',
            hideOnExport: true,
            cell: (user) => <ListBtn onClick={() => goToUserDances(user)} />,
        },

        {
            property: 'edit',
            label: i18n.t('users_table.edit'),
            align: 'center',
            minWidth: 'none',
            hideOnExport: true,
            cell: (user) => <EditBtn onClick={() => goToEditUser(user)} />,
        },
        {
            property: 'expand',
            label: '',
            dataScope: 'col',
            align: 'start',
            minWidth: '60px',
            hideOnExport: true,
            cell: (row, col, onClick, expanded) => (
                <ExpandButton
                    onClick={onClick}
                    expanded={expanded}
                    closedText={i18n.t('table.show_more_details')}
                    expandedText={i18n.t('table.show_less_details')}
                />
            ),
        },
    ]

    const goToEditUser = (user) => {
        history.push({
            pathname: '/edit_user/' + user.id,
            state: { user },
        })
    }
    const goToUserDances = (user) => {
        history.push({
            pathname: '/dances',
            state: {
                searchByUser: user,
            },
        })
    }

    return (
        <PaginatedTable
            title={i18n.t('users_table_filters.users_title')}
            collection={'users'}
            columns={columns}
            filters={filters}
            loadAction={getAllUsers}
            useFunction={useUsers}
            ExpandedRowComponent={UserExpandedRow}
        />
    )
}
